import { useModalDismiss } from '../hooks/useModalDismiss';
import React, { useState } from 'react';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, interviewerName }) => {
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason.trim()) return;
        
        setLoading(true);
        await onConfirm(reason);
        setLoading(false);
        setReason('');
        onClose();
    };

    const handleClose = () => {
        setReason('');
        onClose();
    };

    // Escape only: this overlay has never closed on a backdrop click.
    useModalDismiss(handleClose, { backdropClose: false, enabled: isOpen });

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
            <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
                <div className="mt-3">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                        <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                    </div>
                    <div className="mt-2 px-7 py-3">
                        <h3 className="text-lg font-medium text-gray-900 text-center">
                            Confirmer la suppression
                        </h3>
                        <div className="mt-2 px-7 py-3">
                            <p className="text-sm text-gray-500 text-center">
                                Êtes-vous sûr de vouloir archiver l'enquêteur <strong>{interviewerName}</strong> ?
                            </p>
                        </div>
                    </div>
                    
                    <form onSubmit={handleSubmit} className="px-7 py-3">
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Raison de l'archivage *
                            </label>
                            <textarea
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                                rows="3"
                                placeholder="Expliquez pourquoi cet enquêteur est archivé..."
                                required
                            />
                        </div>
                        
                        <div className="flex justify-end space-x-3">
                            <button
                                type="button"
                                onClick={handleClose}
                                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
                            >
                                Annuler
                            </button>
                            <button
                                type="submit"
                                disabled={loading || !reason.trim()}
                                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {loading ? 'Archivage...' : 'Archiver'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
